import BENNDORF_EXT_1 from "./BENNDORF_EXT_1";
export default {
  BENNDORF_EXT_1,
};
